import {
  addDoc,
  collection,
  doc,
  getDocs,
  serverTimestamp,
  updateDoc
} from 'firebase/firestore';
import { db } from '../../firebase';
import { FINANCE_COLLECTIONS } from './financeCostConstants';
import { toFiniteNumber } from './financeGoldRate';
import { istanbulDateKey } from './financePeriod';
import { isActiveExpense } from './financePnl';

export function financeExpensesCol(sube) {
  return collection(db, 'subeler', sube, FINANCE_COLLECTIONS.EXPENSES);
}

export function normalizeExpense(row) {
  const category = row.category || row.kalem || 'diger';
  const amountTry = row.amountTry != null && row.amountTry !== '' ? toFiniteNumber(row.amountTry) : toFiniteNumber(row.tutar);
  const expenseDate = row.expenseDate || row.tarih || '';
  const title = String(row.title || row.aciklama || category).trim();
  return {
    ...row,
    title,
    category,
    period: row.period || 'monthly',
    expenseType: row.expenseType || row.tur || 'sabit',
    amountTry,
    expenseDate,
    description: String(row.description || row.aciklama || ''),
    paymentMethod: row.paymentMethod || row.odeme || '',
    personelId: row.personelId || null,
    personelName: row.personelName || null,
    status: row.status || 'active',
    tutar: amountTry,
    tarih: expenseDate,
    kalem: category,
    aciklama: String(row.description || row.aciklama || '')
  };
}

export async function loadFinanceExpenses(sube) {
  if (!sube) return [];
  const snap = await getDocs(financeExpensesCol(sube));
  return snap.docs
    .map((d) => normalizeExpense({ id: d.id, ...d.data() }))
    .sort((a, b) => String(a.title || '').localeCompare(String(b.title || ''), 'tr'));
}

function personelStamp(personel) {
  return personel
    ? { id: personel.id || null, isim: personel.isim || '', soyisim: personel.soyisim || '' }
    : null;
}

export async function addFinanceExpense(sube, payload, personel) {
  const amountTry = Math.round(toFiniteNumber(payload.amountTry ?? payload.tutar) * 100) / 100;
  if (!sube || amountTry <= 0) {
    throw new Error('Gider tutarı geçersiz.');
  }
  const category = payload.category || payload.kalem || 'diger';
  const title = String(payload.title || payload.aciklama || category).trim();
  const description = String(payload.description || payload.aciklama || '').trim();
  const createdKey = istanbulDateKey(new Date());
  await addDoc(financeExpensesCol(sube), {
    sube,
    title,
    category,
    period: 'monthly',
    expenseType: 'sabit',
    amountTry,
    expenseDate: createdKey,
    description,
    paymentMethod: '',
    personelId: payload.personelId || null,
    personelName: payload.personelName || null,
    status: 'active',
    tarih: createdKey,
    tutar: amountTry,
    kalem: category,
    aciklama: description,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    createdBy: personelStamp(personel),
    updatedBy: personelStamp(personel)
  });
}

export async function updateFinanceExpense(sube, id, payload, personel) {
  if (!sube || !id) return;
  const amountTry = Math.round(toFiniteNumber(payload.amountTry ?? payload.tutar) * 100) / 100;
  if (amountTry <= 0) throw new Error('Gider tutarı geçersiz.');
  const category = payload.category || payload.kalem || 'diger';
  const description = String(payload.description || payload.aciklama || '').trim();
  await updateDoc(doc(db, 'subeler', sube, FINANCE_COLLECTIONS.EXPENSES, id), {
    title: String(payload.title || description || category).trim(),
    category,
    period: 'monthly',
    expenseType: 'sabit',
    amountTry,
    description,
    paymentMethod: '',
    personelId: payload.personelId || null,
    personelName: payload.personelName || null,
    tutar: amountTry,
    kalem: category,
    aciklama: description,
    updatedAt: serverTimestamp(),
    updatedBy: personelStamp(personel)
  });
}

export async function cancelFinanceExpense(sube, id, personel) {
  if (!sube || !id) return;
  await updateDoc(doc(db, 'subeler', sube, FINANCE_COLLECTIONS.EXPENSES, id), {
    status: 'cancelled',
    cancelledAt: serverTimestamp(),
    cancelledBy: personelStamp(personel),
    updatedAt: serverTimestamp(),
    updatedBy: personelStamp(personel)
  });
}

export { isActiveExpense };
